'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  color: ', ';\n  font-family: ', ';\n  font-size: ', 'px;\n  text-align: ', ';\n  opacity: ', ';\n  ', '\n'], ['\n  color: ', ';\n  font-family: ', ';\n  font-size: ', 'px;\n  text-align: ', ';\n  opacity: ', ';\n  ', '\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _helpers = require('../../helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var NitroParagraph = _styledComponents2.default.p(_templateObject, function (props) {
  return props.theme.color[props.variant];
}, function (props) {
  return props.bold ? props.theme.font.bold : props.theme.font.default;
}, function (props) {
  return props.theme.size[props.size] || props.size;
}, function (props) {
  return props.align;
}, function (props) {
  return props.opacity;
}, (0, _helpers.boolStyle)('noMargin', 'margin: 0;'));

NitroParagraph.displayName = 'NitroParagraph';
NitroParagraph.defaultProps = {
  variant: 'base2',
  size: '3',
  align: 'left',
  opacity: '1'
};

NitroParagraph.propTypes = {
  className: _propTypes2.default.string,
  variant: _propTypes2.default.string,
  bold: _propTypes2.default.bool,
  size: _propTypes2.default.string,
  align: _propTypes2.default.string,
  noMargin: _propTypes2.default.bool,
  opacity: _propTypes2.default.string
};

exports.default = NitroParagraph;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-paragraph/NitroParagraph.js
// module id = 3025
// module chunks = 4